import { MockDebug } from '@tino-frontend/mocks'
import { REACT_APP_SUPPLIER_BFF_API_URL } from 'constants/envs'
import {
  CreatePaymentLinkPayload,
  GetMerchantsResponseData,
  MerchantContact,
  MerchantResponse,
} from '@types'

const MockDebugMerchants: MockDebug = {
  title: 'Lista de Merchants',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/merchants`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-merchants-success',
      title: 'Sucesso',
      status: 200,
      data: {
        merchants: [
          {
            id: '1',
            name: 'Lojista com limite disponível 1',
            document_number: '56911633000106',
            status: 'able_to_transact',
            created_at: new Date('2023-12-01T00:00:00Z'),
          },
          {
            id: '2',
            name: 'Lojista com limite disponível 2',
            document_number: '92167553000151',
            status: 'able_to_transact',
            created_at: new Date('2023-12-01T00:00:00Z'),
          },
          {
            id: '3',
            name: 'Lojista com limite pendente',
            document_number: '24147194000110',
            status: 'limit_pending',
            created_at: new Date('2023-12-01T00:00:00Z'),
          },
        ] as MerchantResponse[],
      } as GetMerchantsResponseData,
    },
    {
      id: 'mock-merchants-empty',
      title: 'Lista vazia',
      status: 200,
      data: {
        merchants: [] as MerchantResponse[],
      } as GetMerchantsResponseData,
    },
    {
      id: 'mock-merchants-error',
      title: 'Erro',
      status: 500,
      data: {
        message: 'Internal Server Error',
      },
    },
  ],
}

const MockDebugLastMerchantOrderDetails: MockDebug = {
  title: 'Últimos detalhes de pedido do Merchant',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/suppliers/:supplierId/latest-order`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-last-merchant-order-details-success',
      title: 'Sucesso',
      status: 200,
      data: {
        external_id: 'EXT12345',
        supplier_company_id: '0ab0bc59-43db-487c-b0ec-898625a88f92',
        requester_user_id: '1119a195-b8ca-4110-87f5-d37821ccad07',
        merchant_document_number: '40970583000106',
        amount_cents: 150000,
        phone_number: '11954661546',
        email: 'financeiro@lojista.com.br',
        max_due_day: 60,
        zip_code: '01234567',
        address: 'Rua Exemplo',
        street_number: '123',
        city: 'São Paulo',
        state: 'SP',
        origin: 'link-salesperson',
        confirmed_by_salesperson: true,
      } as CreatePaymentLinkPayload,
    },
    {
      id: 'mock-last-merchant-order-details-error',
      title: 'Erro',
      status: 404,
      data: {
        message: 'Merchant not found',
      },
    },
  ],
}

// Mock para getMerchantContacts
const MockDebugMerchantContacts: MockDebug = {
  title: 'Contatos do Merchant',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/suppliers/:supplierId/merchants/:merchantDocumentNumber/contacts`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-merchant-contacts-success',
      title: 'Sucesso com múltiplos contatos',
      status: 200,
      data: {
        contacts: [
          {
            email: 'contato1@lojista.com.br',
            name: 'João Silva',
            phone: '+55911987654321',
            user_id: 'user-id-1',
          },
          {
            email: 'contato2@lojista.com.br',
            name: 'Maria Souza',
            phone: '+55911912345678',
            user_id: 'user-id-2',
          },
          {
            email: 'financeiro@lojista.com.br',
            name: 'Carlos Finanças',
            phone: '+55911955554444',
            user_id: 'user-id-3',
          },
        ] as MerchantContact[],
      },
    },
    {
      id: 'mock-merchant-contacts-single',
      title: 'Sucesso com um contato',
      status: 200,
      data: {
        contacts: [
          {
            email: 'contato@lojista.com.br',
            name: 'José Comercial',
            phone: '+55911922223333',
            user_id: 'user-id-4',
          },
        ] as MerchantContact[],
      },
    },
    {
      id: 'mock-merchant-contacts-empty',
      title: 'Sem contatos',
      status: 200,
      data: {
        contacts: [] as MerchantContact[],
      },
    },
    {
      id: 'mock-merchant-contacts-error',
      title: 'Erro',
      status: 404,
      data: {
        message: 'Merchant not found',
      },
    },
  ],
}

const MockDebugMerchantRatings: MockDebug = {
  title: 'Merchant Ratings',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/ratings`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-merchant-ratings-success',
      title: 'Sucesso',
      status: 200,
      data: {
        company_name: 'Empresa Exemplo',
        document_number: '12345678000199',
        status: 'able_to_transact',
        available_limit_cents: 5000000,
        total_limit_cents: 10000000,
        score: 85,
        rating: 'A',
        receita_federal_status: 'ATIVA',
        civil_actions: 0,
        bad_checks: 0,
        stopped_checks: 0,
        judicial_protests: 0,
        number_of_partners: 2,
        bankruptcy_recovery: 0,
        informed_return_checks: 0,
        external_credit_usage: 0,
        has_external_credit: false,
        receita_federal_opening_date: '2010-01-01',
      },
    },
    {
      id: 'mock-merchant-ratings-not-found',
      title: 'Não encontrado',
      status: 404,
      data: { message: 'Merchant ratings not found' },
    },
  ],
}

const MockDebugMerchantProfile: MockDebug = {
  title: 'Perfil do Merchant',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/suppliers/:supplierId/merchants/:merchantDocumentNumber`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-merchant-profile-success',
      title: 'Sucesso',
      status: 200,
      data: {
        id: 'merchant-123',
        available_limit_cents: 5000000,
        company_name: 'Empresa Exemplo',
        document_number: '12345678000199',
        is_able_to_transact: true,
        status: 'able_to_transact',
        total_limit_cents: 10000000,
        users: [
          { email: 'contato@empresa.com.br' },
          { email: 'financeiro@empresa.com.br' },
        ],
      },
    },
    {
      id: 'mock-merchant-profile-not-found',
      title: 'Não encontrado',
      status: 404,
      data: { message: 'Merchant not found' },
    },
  ],
}

export const MockDebugMerchant = [
  MockDebugMerchants,
  MockDebugLastMerchantOrderDetails,
  MockDebugMerchantContacts,
  MockDebugMerchantRatings,
  MockDebugMerchantProfile,
]

export default MockDebugMerchant
